import React from 'react';

const Homepage = () => {
  return (
    <div>
      <a
        href="https://github.com/soumsps/react-animation-library/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Read Documentation
      </a>
    </div>
  );
};

export default Homepage;
